import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <h1>{{ 'manage.Integration error log' | translate }}</h1>
        <div class="alert alert-plain ng-scope">
            <p>{{ 'integrationLog.In this list, errors from employee data integration are displayed' | translate }}</p>
        </div>
        <manage-logs-integrationlog-filter list="vm.list" default-filter="vm.defaultFilter"></manage-logs-integrationlog-filter>
        <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
        <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
            <pagination-tools list="vm.list"></pagination-tools>
            <table
                class="data01"
                datatable
                dt-options="vm.DATATABLES"
            >
                <thead>
                    <tr>
                        <th>{{ 'integrationLog.Time' | translate }}</th>
                        <th>{{ 'integrationLog.Integration type' | translate }}</th>
                        <th>{{ 'integrationLog.Error' | translate }}</th>
                        <th>{{ 'integrationLog.External ID' | translate }}</th>
                        <th class="none">{{ 'integrationLog.Data from integration' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items">
                        <td>{{ vm.moment(item.createdAt * 1000).format('DD.MM.YYYY HH:mm:ss') }}</td>
                        <td>{{ vm.INTEGRATIONLOG_TYPE_ENUM.LABELS[item.type] }}</td>
                        <td>{{ item.error }}</td>
                        <td>{{ item.externalId }}</td>
                        <td>
                            <pre ng-if="item.user">{{ 'integrationLog.Employee' | translate }}: {{ item.user.displayName }}</pre>
                            <pre>{{ vm.jsonParse(item.data) }}</pre>
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    `
})
export default class {
    constructor ($state, $translate, moment, ListFactory, IntegrationLogResource,
                 DATATABLES, INTEGRATIONLOG_TYPE_ENUM) {
        this.$state = $state;
        this.$translate = $translate;
        this.moment = moment;
        this.ListFactory = ListFactory;
        this.IntegrationLogResource = IntegrationLogResource;
        this.DATATABLES = DATATABLES;
        this.INTEGRATIONLOG_TYPE_ENUM = INTEGRATIONLOG_TYPE_ENUM;
    }

    $onInit () {
        this.defaultFilter = {
            from: this.moment().subtract(14, 'days').format('YYYY-MM-DD'),
            expand: 'user'
        };
        this.list = this.ListFactory.createWithPagination(this.IntegrationLogResource.query.bind(this.IntegrationLogResource));
        // we set perPage via pagination to avoid resetting it when using filter
        this.list.pagination.perPage = 50;
        this.list.fetch(this.defaultFilter);
    }

    jsonParse (data) {
        return JSON.stringify(JSON.parse(data), null, ' ');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/logs/integrationlog/index.js